import React from "react";
import { Wrapper as PageWrapper } from "@containers/PageWrapper";
import { BankStatementForm } from "@containers/PersonalLoan/containers/BankStatementStep/bankStatementForm";
import { Paper } from "@components/paper";
import ContentWrapper from "../../components/contentWrapper";
import { useMissingAccountExternalIdRedirect } from "@hooks";
import { postBankStatement } from "../../services/personalLoanApi";
import { useSelector } from "react-redux";

export const BankStatements = () => {
  const { queryString } = useSelector((state) => state.StartUp);
  const { id } = queryString;
  useMissingAccountExternalIdRedirect();

  const submitBankStatement = (fieldName, fieldValue) => {
    postBankStatement(id, fieldValue);
  };

  return (
    <PageWrapper>
      <Paper>
        <ContentWrapper>
          <main>
            <BankStatementForm
              setFieldValue={submitBankStatement}
              show
              allowSkip={false}
            />
          </main>
        </ContentWrapper>
      </Paper>
    </PageWrapper>
  );
};
